// extracted by mini-css-extract-plugin
module.exports = {"share":"social-share_share__aT8JY"};